import { MockInterviewCTA } from "./MockInterviewCTA/MockInterviewCTA";
import { ResumeImprovementsCTA } from "./ResumeImprovementsCTA/ResumeImprovementsCTA";
import { useJsInterviewPrepResumeImprovements } from "../../../../../interview-prep/hooks/useJsInterviewPrepResumeImprovements";
import { useViewjobOneGraphModel } from "../../../context/ViewJobDataContext";
import { ScreenDisplay } from "../../../context/ViewJobScreenDisplay";

import React from "react";

export const InterviewPrepCTA: React.FunctionComponent = () => {
  const vjModel = useViewjobOneGraphModel();
  const isResumeImprovementsCtaEnabled =
    vjModel?.features?.isVjResumeImprovementsCtaTstActive ?? false;

  const { shouldShowCta, loading, extractionId } = useJsInterviewPrepResumeImprovements({
    skip: !isResumeImprovementsCtaEnabled,
    source: "viewjob",
  });

  if (!vjModel) {
    return null;
  } else if (isResumeImprovementsCtaEnabled && loading) {
    return null;
  } else if (isResumeImprovementsCtaEnabled && shouldShowCta) {
    return (
      <ScreenDisplay.MobileOnly>
        <ResumeImprovementsCTA extractionId={extractionId} />
      </ScreenDisplay.MobileOnly>
    );
  } else {
    return <MockInterviewCTA />;
  }
};
